import { Component } from '@angular/core';

@Component({
  selector: 'app-update-dialog',
  templateUrl: './update-dialog.component.html',
  standalone: false,
  styleUrls: ['./update-dialog.component.scss'],
})
export class UpdateDialogComponent {
  onReloadClick(): void {
    window.location.reload();
  }
}
